/*
 Copyright 2025 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Gallery API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CollectionPermission = 'ViewCollection' | 'EditCollection' | 'ManageCollection';

export const CollectionPermission = {
    ViewCollection: 'ViewCollection' as CollectionPermission,
    EditCollection: 'EditCollection' as CollectionPermission,
    ManageCollection: 'ManageCollection' as CollectionPermission
};

